// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cdb87ee7","977":"fab878a7"}[chunkId] + ".chunk.js";
};